(() => {
  'use strict';

  const isHomepage = () => window.location.pathname === '/' || window.location.pathname === '';

  const indicators = new Map();

  const initIndicators = () => {
    document.querySelectorAll('.menu-quicklinks').forEach(section => {
      const container = section.querySelector('.menu-quicklinks__container');
      const indicator = section.querySelector('.menu-quicklinks__indicator');
      if (!container || !indicator) return;

      const update = () => {
        const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 4;
        indicator.classList.toggle('menu-quicklinks__indicator--hidden', atEnd);
      };

      indicator.addEventListener('click', () => {
        container.scrollBy({ left: 160, behavior: 'smooth' });
      });

      container.addEventListener('scroll', update, { passive: true });
      indicators.set(section, update);
    });
  };

  const getTargets = (sectionId) => {
    if (sectionId) {
      const el = document.getElementById(sectionId);
      return el ? [el] : [];
    }
    return [...document.querySelectorAll('.menu-quicklinks')];
  };

  window.convertMenuQuicklinks = {
    control: function(sectionId) {
      getTargets(sectionId).forEach(el => el.classList.remove('is-visible'));
    },

    variant: function(sectionId) {
      if (!isHomepage()) return;
      getTargets(sectionId).forEach(el => {
        el.classList.add('is-visible');
        indicators.get(el)?.();
      });
    },

    reset: function(sectionId) {
      this.control(sectionId);
    }
  };

  const init = () => {
    window.convertMenuQuicklinks.control();
    initIndicators();
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:load', init);
})();
